export default (function (theme) {
  return {
    root: {
      display: 'block',
      borderBottom: "1px solid ".concat(theme.colors.neutral400)
    },
    text: {
      padding: '8px 0'
    }
  };
});